import serverApi from "../utils/serverApi"

const documentVersioningService = {
  getDocument: () => serverApi({ uri: 'document-versioning', method: 'GET', isLoading: false }),

  markAgreeDocument: (body) => serverApi({ uri: 'document-versioning', method: 'POST', data: body, isLoading: false }),
};

export default documentVersioningService;
